<template>
  <div class="modal-content ion-padding ion-text-center">
    <modal-close />
    <roodie fillOuter="#5E58BE" :expression="'happy'" />
    <h6 v-if="message">
      {{ message }}
    </h6>
    <div class="ion-margin-top">
      <ion-button
        v-for="(button, index) in buttons"
        :key="index"
        @click="
          (button.handler && button.handler(true)) ||
            modalController.dismiss({ button: button })
        "
        >{{ button.text || button }}</ion-button
      >
    </div>
  </div>
</template>

<script>
import Roodie from "@lib/components/svg/Roodie";
import { modalController, IonButton } from "@ionic/vue";
import ModalClose from "@lib/components/ModalClose";

export default {
  components: {
    Roodie,
    IonButton,
    ModalClose,
  },
  props: {
    message: {
      type: String,
      required: false,
      default: "",
    },
    buttons: {
      type: Array,
      required: false,
      default: () => {
        return [];
      },
    },
  },
  setup() {
    return { modalController };
  },
};
</script>

<style></style>
